import { Box, CSSObject, Grid, Theme, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { Close } from '@mui/icons-material';
import Button from 'domains/core/components/Button';
import theme from 'theme';

const previewHeader: CSSObject = {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
};
const previewHeaderElements: CSSObject = {
    padding: `0 ${theme.spacing(1)}`,
};
const previewContent: CSSObject = {
    border: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`,
    borderRadius: '6px',
    boxShadow: `${theme.spacing(0.125)} ${theme.spacing(0.125)} 0 ${theme.palette.primary.main}`,
    height: '100%',
    overflow: 'scroll',
};

export type Props = {
    isCloseEnabled?: boolean;
    /** Set to true if this is rendered as an item inside a MUI Grid component. */
    isGridItem?: boolean;
    isOpen: boolean;
    onClose: () => void;

    sx?: SxProps<Theme>;
};

const VoicePreviewContent = ({ isCloseEnabled = true, isGridItem = false, isOpen, onClose, sx }: Props) => {
    if (!isOpen) {
        return null;
    }
    const containerVisibilityStyles: CSSObject = {
        height: '100%',
        zIndex: `${isOpen ? '100' : '-1'}`,
        backgroundColor: '#fff',
        width: '100%',
    };
    return (
        <Grid item={isGridItem} container xs={isGridItem ? true : undefined} height="100%" sx={{ ...sx }}>
            <Box sx={containerVisibilityStyles}>
                <Grid item container xs sx={previewHeader}>
                    <Typography variant="overline" color={theme.palette.action.active} sx={previewHeaderElements}>
                        {`content preview`}
                    </Typography>
                    {isCloseEnabled && (
                        <Button
                            variant="text"
                            size="small"
                            endIcon={<Close />}
                            onClick={onClose}
                            sx={previewHeaderElements}
                        >
                            Close Preview
                        </Button>
                    )}
                </Grid>
                <Grid item container sx={previewContent}></Grid>
            </Box>
        </Grid>
    );
};

export default VoicePreviewContent;
